export default function SectionBlock({ title, count, children }) {
  return (
    <section className="mb-3.5 rounded-2xl border border-line bg-white px-5 py-4">
      <header className="mb-3.5 flex items-center justify-between">
        <h3 className="text-[11px] font-semibold uppercase tracking-[1.5px] text-fiscal-fg">{title}</h3>
        {count != null && <span className="text-[11px] text-muted">{count} fait{count > 1 ? 's' : ''}</span>}
      </header>
      {children}
    </section>
  )
}
